import { useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom'
import FooterNew from "../components/FooterNew";
import HeaderLogoSection from "../components/HeaderLogoSection";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { activateSocialEmail, activateSocialEmailClear, resendActivationLink, resendActivationLinkClear } from "../redux/auth/actions";
import CONFIG from "../utils/config";
import MESSAGE from "../utils/messages";
import Loader from "../components/Loader/Loader";


const SocialLoginActivation = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const c = params.get("c");
	let decodedString = atob(c);
	let paramsReq = JSON.parse(decodedString);

  const key = paramsReq.key;
  const email = paramsReq.email;
    // const key = params.get('key');  // this is like token
    // const email = params.get('email');

    const activateSocialEmailRes = useSelector(state => state.auth.activateSocialEmailRes)
    const resendLink = useSelector(state => { return state.auth.resendLink })

    const [htmlFormError, setFormError] = useState('')
    const [htmlFormSuccess, setFormSuccess] = useState('')
    const [isActivated, setIsActivated] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isAlreadyActivated, setIsAlreadyActivated] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        dispatch(activateSocialEmail({
            module: "activateSocialEmail",
            postData: {
                email: email,
                token: key
            }
        }))
    }, [key])

    useEffect(() => {
        console.log('activateEmailRes: ', activateSocialEmailRes)
        if (!_.isEmpty(activateSocialEmailRes)) {
            setIsLoading(false);
            if (activateSocialEmailRes?.status === "success") {
                setIsActivated(true)
                if (activateSocialEmailRes?.payload.payload.isActivated === 1) {
                    setIsAlreadyActivated(true)
                } else {
                    setIsAlreadyActivated(false)
                }
            } else {
                setIsActivated(false)
                setIsAlreadyActivated(false)
            }

            dispatch(activateSocialEmailClear())
        }

    }, [activateSocialEmailRes])

    useEffect(() => {
        // console.log(resendLink)
        if (!_.isEmpty(resendLink)) {
            // console.log('not empty')
            setIsLoading(false);
            dispatch(resendActivationLinkClear())
            if (resendLink.status === 'success') {
                setFormSuccess('Activation link has been resent to your email.')
                setTimeout(() => {
                    // console.log('Redirect to login', email)
                    setFormSuccess('')
                }, 5000)
                // navigate(`/`, { canLogin: true })
            } else {
                // console.log('Redirect to error', email)
                setFormError(resendLink.error.message)
                setTimeout(() => {
                    setFormError('')
                }, 5000)
            }

        }
    }, [resendLink])

    const resend = () => {
        setIsLoading(true);
        dispatch(resendActivationLink({
            module: 'resend-verification-email',
            postData: {
                email: email
            }
        }))
    }

    return (
        <>
            <Loader start={isLoading} />
            <div className="login-ary setup-password">
        <section className="login-sec ">
          <div className="login-container">
            {/* <div className="bannerlog-image d-block d-md-none image-login">
              <img className="img-fluid" src="/images/finwell-img/banner.png" />
            </div> */}
            <div className="container-fluid">
              <div className="row bglogin">
                <div className="col-xl-7 col-lg-6 col-sm-12 col-12 image-login">
                  <img
                    className="img-fluid"
                    src="/images/finwell-img/banner.png"
                    alt="home-scene-login"
                  />
                </div>
                <div className="col-xl-5 col-lg-6 col-sm-12 col-12 ttxt">
                  <div className="login-text">
                    <div className="text-center lgo-box">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 60 60"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g filter="url(#filter0_d_3752_2008)">
                          <rect
                            x="2"
                            y="1"
                            width="56"
                            height="56"
                            rx="12"
                            fill="white"
                          />
                          <rect
                            x="2.5"
                            y="1.5"
                            width="55"
                            height="55"
                            rx="11.5"
                            stroke="#EAECF0"
                          />
                          <path
                            d="M18.334 23.1641L27.8597 29.8321C28.6311 30.372 29.0168 30.642 29.4363 30.7466C29.8069 30.839 30.1944 30.839 30.565 30.7466C30.9845 30.642 31.3702 30.372 32.1416 29.8321L41.6673 23.1641M23.934 38.3307H36.0673C38.0275 38.3307 39.0076 38.3307 39.7563 37.9493C40.4149 37.6137 40.9503 37.0783 41.2858 36.4197C41.6673 35.671 41.6673 34.6909 41.6673 32.7307V25.2641C41.6673 23.3039 41.6673 22.3238 41.2858 21.5751C40.9503 20.9165 40.4149 20.3811 39.7563 20.0455C39.0076 19.6641 38.0275 19.6641 36.0673 19.6641H23.934C21.9738 19.6641 20.9937 19.6641 20.245 20.0455C19.5865 20.3811 19.051 20.9165 18.7155 21.5751C18.334 22.3238 18.334 23.3039 18.334 25.2641V32.7307C18.334 34.6909 18.334 35.671 18.7155 36.4197C19.051 37.0783 19.5865 37.6137 20.245 37.9493C20.9937 38.3307 21.9738 38.3307 23.934 38.3307Z"
                            stroke="#344054"
                            strokeWidth="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <filter
                            id="filter0_d_3752_2008"
                            x="0"
                            y="0"
                            width="60"
                            height="60"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dy="1" />
                            <feGaussianBlur stdDeviation="1" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_3752_2008"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_3752_2008"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>
                    </div>
                        <div className="activation-link text-center mt-4">
                            {isActivated === null ? "" :
                                isActivated && !isAlreadyActivated ? <>
                                    <p>{"Your account has been activated successfully."}</p>
                                    <p>Please click <u style={{ color: 'royalblue' }} className="cursor-pointer" onClick={() => {
                                        localStorage.clear();
                                        navigate('/login')
                                    }}>here</u> to Sign in.</p>
                                </> : <div className="expired-link">

                                        <p>{MESSAGE.LINK_EXPIRED}</p>
                                        {
                                            !isAlreadyActivated && <p>
                                                <i style={{ 'fontWeight': '100' }}>
                                                    Click&nbsp;
                                                    <u style={{ color: 'royalblue' }} onClick={() => resend()} className="cursor-pointer">here</u>&nbsp;
                                                    to request a new link.
                                                </i>
                                            </p>
                                        }
                                        <div className="mb-2 login-msg">
                                        {htmlFormError && (<div className="mt-2 text-danger" style={{ 'font-size': '13px' }}>{htmlFormError}</div>)}
                                        {htmlFormSuccess && (<div className="mt-2 text-success" style={{ 'font-size': '13px' }}>{htmlFormSuccess}</div>)}
                                        </div>
                                </div>}

                        </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
        </>
    );

}
export default SocialLoginActivation;